export default __webpack_public_path__ + "static/media/M_floating.2c84a948.png";